import { render, staticRenderFns } from "./AppNavigationHeaderViewMenu.vue?vue&type=template&id=1d89dc7f&"
import script from "./AppNavigationHeaderViewMenu.vue?vue&type=script&lang=js&"
export * from "./AppNavigationHeaderViewMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d89dc7f')) {
      api.createRecord('1d89dc7f', component.options)
    } else {
      api.reload('1d89dc7f', component.options)
    }
    module.hot.accept("./AppNavigationHeaderViewMenu.vue?vue&type=template&id=1d89dc7f&", function () {
      api.rerender('1d89dc7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/AppNavigationHeader/AppNavigationHeaderViewMenu.vue"
export default component.exports